import { makeStyles } from '@fluentui/react-components';

export const useStackStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
  },
  reversed: {
    flexDirection: 'row-reverse',
  },
  wrap: {
    flexWrap: 'wrap',
  },
  nowrap: {
    flexWrap: 'initial',
  },
  verticalFill: {
    height: '100%',
  },
  verticalAuto: {
    height: 'auto',
  },
});

export const useStackDirectionStyles = makeStyles({
  vertical: {
    flexDirection: 'column',
  },
  horizontal: {
    flexDirection: 'row',
  },
  verticalReversed: {
    flexDirection: 'column-reverse',
  },
  horizontalReversed: {
    flexDirection: 'row-reverse',
  },
});

export const useVerticalAlignmentStyles = makeStyles({
  // styles matching the Alignment Type from the Stack component
  start: {
    alignContent: 'flex-start',
  },
  end: {
    alignContent: 'flex-end',
  },
  center: {
    alignContent: 'center',
  },
  'space-between': {
    alignContent: 'space-between',
  },
  'space-around': {
    alignContent: 'space-around',
  },
  'space-evenly': {
    alignContent: 'space-evenly',
  },
  baseline: {
    alignContent: 'baseline',
  },
  stretch: {
    alignContent: 'stretch',
  },
});

export const useHorizontalAlignmentStyles = makeStyles({
  // styles matching the Alignment Type from the Stack component
  start: {
    justifyContent: 'flex-start',
  },
  end: {
    justifyContent: 'flex-end',
  },
  center: {
    justifyContent: 'center',
  },
  'space-between': {
    justifyContent: 'space-between',
  },
  'space-around': {
    justifyContent: 'space-around',
  },
  'space-evenly': {
    justifyContent: 'space-evenly',
  },
  baseline: {
    justifyContent: 'baseline',
  },
  stretch: {
    justifyContent: 'stretch',
  },
});
